/**
 * @fileoverview Agent definition for the chapter-metadata-extractor-v1 primitive.
 *
 * Extracts rich metadata (keyEvents, chapterGoals, scenes, pacing, POV)
 * for a single chapter, given confirmed boundaries and a scoped text region.
 * Step 3 of the human-gated extraction workflow.
 *
 * @category import.story.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'chapter-metadata-extractor-v1',
  kind: 'primitive',
  name: 'Chapter Metadata Extractor',
  description: 'Extracts rich metadata (keyEvents, chapterGoals, scenes, pacing, POV) for a single chapter from confirmed boundaries and scoped text.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'import.story.extraction',
    usedBy: ['use-robust-chapter-extraction-workflow-v1.ts'],
    relatedAgents: ['chapter-boundary-detector-v1', 'chapter-extractor-v2', 'robust-chapter-formatter-v1'],
  },
};
